const clearStorage = () => {
    // Clear storage...
    console.log("Entered into localstorage clear logic");
    localStorage.removeItem("initialPath")
    localStorage.removeItem("unsubscribePath"); 
    localStorage.removeItem("isNMBSLoginInitiated");
    localStorage.removeItem("languageCode");
    localStorage.removeItem("InitialLogin");
    localStorage.removeItem("languageCode");
    localStorage.removeItem("IdentityToken");
    localStorage.removeItem("code");
    localStorage.removeItem("isFormLoaded");
    localStorage.removeItem("languagePref");
}

export default clearStorage;